// Object for global variables
var Vars = Vars || {};
window.Vars = Vars;
Vars.matchMedia = Modernizr.mobile ? 'm' : Modernizr.tablet ? 't' : 'd';
Vars.searchRadius = 100;
Vars.transitionEnd =
  'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend';
Vars.bLazyOptions = {
  selector: '.lazy',
  offset: 100,
  breakpoints: [
    {
      width: 1400,
      src: 'data-src-larger',
    },
    {
      width: 1200,
      src: 'data-src-large',
    },
    {
      width: 992,
      src: 'data-src-desktop',
    },
    {
      width: 768,
      src: 'data-src-tablet',
    },
    {
      width: 480,
      src: 'data-src-mobile',
    },
  ],
};

// Global DOM variables which doesn't fit in `Vars`
window.$document = $(document);
window.$window = $(window);
window.$html = $('html');
window.$body = $('body');
window.$htmlBody = $html.add($body);
window.$navBtn = $('.header-nav-icon');
window.$searchOpenBtn = $('.search-label .icon');
window.windowWidth = window.innerWidth;
window.windowHeight = window.innerHeight;
window.devicePxRatio = window.devicePixelRatio;

/**
 * Global init function
 * @param  {string} parent 		segment_1 of the URL
 * @param  {string} child   	segment_2 of the URL
 */
window.App = function (parent, child) {
  // Create new instance if function called withour `new`
  if (!(this instanceof App)) return new App(parent, child);
  var _ = this;

  Vars.parent = parent.length ? parent : 'home';
  Vars.child = child;

  /* ================================
   * Dev stuff, to remove on prod
   * ================================ */

  // Prevent scrollTop on click on a[href="#"] links
  $('a[href="#"]').on('click', function (e) {
    e.preventDefault();
  });

  /* ================================
   * ./Dev stuff, to remove on prod
   * ================================ */

  /* ================================
   * Init global
   * ================================ */

  // Smooth scroll for anchors link
  $('.smooth-scroll').on('click', Utils.smoothScroll);

  $('.smooth-scroll').on('click', function (e) {
    e.preventDefault();
  });

  $('.js-scroll-to').on('click', { offset: $('.main-header').outerHeight() }, Utils.smoothScroll);

  // Init promo sliders
  if ($('.js-promo').length > 0) {
    $('.js-promo').parent('.promo-item').flickity({
      cellAlign: 'left',
      pageDots: true,
      prevNextButtons: false,
      autoPlay: 3000,
      wrapAround: true,
    });
  }

  if ($('.notice').length > 0) {
    $('.notice__close').on('click', function (event) {
      event.preventDefault();
      $('.notice').addClass('notice--hide');
    });
  }

  // Vars.bLazy = new Blazy(bLazyOptions);

  // Placeholder
  $('.placeholder-input').on('paste input keydown focusin focusout', function () {
    var $this = $(this);

    if ($this.val() !== '') {
      $this.addClass('is-filled');
    } else {
      $this.removeClass('is-filled');
    }
  });

  $navBtn.on('click', function () {
    $body.toggleClass('header-is-open');
  });

  $searchOpenBtn.on('click', function () {
    $body.toggleClass('search-is-open');
  });

  // Resize timer function to update windowWidth
  var resizeTimer;
  $window.on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      windowWidth = window.innerWidth;
      windowHeight = window.innerHeight;
    }, 100);
  });

  /* ================================
   * ./Init global
   * ================================ */

  /* ================================
   * Header
   * ================================ */

  var $navItem = $('.main-menu_item');
  var $lang = $('.main-lang_item');
  var $search = $('.main-search, .main-search_btn');
  var $account = $('.account, .main-account_btn');

  $navItem.on('click', function () {
    $navItem.not($(this)).removeClass('is-opened');

    $(this).toggleClass('is-opened');

    if ($lang.hasClass('is-active')) {
      $lang.removeClass('is-active');
    }

    if ($search.hasClass('is-active')) {
      $search.removeClass('is-active');
    }

    if ($account.hasClass('is-active')) {
      $account.removeClass('is-active');
    }
  });

  // Search button
  $('.main-search_btn').on('click', function () {
    // if (windowWidth > 768) {
    $search.toggleClass('is-active');

    if ($(this).hasClass('is-active')) {
      $('.main-search_input').focus();
    }

    if ($lang.hasClass('is-active')) {
      $lang.removeClass('is-active');
    }

    if ($navItem.hasClass('is-opened')) {
      $navItem.removeClass('is-opened');
    }

    if ($account.hasClass('is-active')) {
      $account.removeClass('is-active');
    }
    // }
  });

  // Languages button
  $('.main-lang_item.current').on('click', function () {
    $lang.toggleClass('is-active');

    if ($search.hasClass('is-active')) {
      $search.removeClass('is-active');
    }

    if ($navItem.hasClass('is-opened')) {
      $navItem.removeClass('is-opened');
    }

    if ($account.hasClass('is-active')) {
      $account.removeClass('is-active');
    }
  });

  // Account button
  $('.main-account_btn, .main-account-close').on('click', function () {
    $account.toggleClass('is-active');

    if ($(this).hasClass('is-active')) {
      $('#main-account').find('input[name="email"]').focus();
    }

    if ($search.hasClass('is-active')) {
      $search.removeClass('is-active');
    }

    if ($navItem.hasClass('is-opened')) {
      $navItem.removeClass('is-opened');
    }

    if ($lang.hasClass('is-active')) {
      $lang.removeClass('is-active');
    }
  });

  // Main closing
  $('.main').on('click', function () {
    if (windowWidth > 768) {
      if ($navItem.hasClass('is-opened')) {
        $navItem.removeClass('is-opened');
      }

      if ($search.hasClass('is-active')) {
        $search.removeClass('is-active');
      }
    }

    if ($account.hasClass('is-active')) {
      $account.removeClass('is-active');
    }

    if ($lang.hasClass('is-active')) {
      $lang.removeClass('is-active');
    }
  });

  // Burger button
  var $responsiveNav = $('.main-nav');

  $('.burger-icon').on('click', function () {
    $responsiveNav.toggleClass('is-shown');
  });

  $('#main').on('click', function () {
    if ($responsiveNav.hasClass('is-shown')) {
      $responsiveNav.removeClass('is-shown');
    }
  });

  /* ================================
   * ./Header
   * ================================ */

  /* ================================
   * Main search
   * ================================ */

  // Create global google services
  Vars.googleService = new google.maps.places.AutocompleteService();
  Vars.googleGeocoder = new google.maps.Geocoder();

  // Launch header global search
  globalSearch('#main-search', '#main-search-input');

  /* ================================
   * Main account
   * ================================ */

  var $reservation = $('#main-account');
  var $resaEmail = $reservation.find('input[name="CustomerEmail"]');
  var $resaNb = $reservation.find('input[name="CustomerResId"]');

  $reservation.on('submit', function (e) {
    e.preventDefault();

    if ($resaEmail.val() === '') {
      // e.preventDefault();

      $resaEmail.addClass('error');
      $resaEmail.on('focus', function () {
        $resaEmail.removeClass('error');
      });
    }

    if ($resaNb.val() === '') {
      // e.preventDefault();

      $resaNb.addClass('error');
      $resaNb.on('focus', function () {
        $resaNb.removeClass('error');
      });
    }

    if ($resaNb.val() && $resaEmail.val()) {
      window.location.href = `${$reservation.attr(
        'action'
      )}email=${$resaEmail.val()}&resid=${$resaNb.val()}`;
    }
  });

  /* ================================
   * Register
   * ================================ */

  var registerButton = $('.account-secondary_register');
  var registerForm = $('.register');

  registerButton.on('click', function () {
    registerForm.toggleClass('showForm');

    if (resetPasswordForm.hasClass('showForm')) {
      resetPasswordForm.removeClass('showForm');
    }
  });

  /* ================================
   * Reset password
   * ================================ */

  var resetPasswordButton = $('.account-secondary_reset-password');
  var resetPasswordForm = $('.reset-password');

  resetPasswordButton.on('click', function () {
    resetPasswordForm.toggleClass('showForm');

    if (registerForm.hasClass('showForm')) {
      registerForm.removeClass('showForm');
    }
  });

  /* ================================
   * Newsletter
   * Sets dynamically newsletter's action in order to avoid site url prefix
   * ================================ */

  var $newsletterForm = $('#mc-embedded-subscribe-form');
  $newsletterForm.attr('action', $newsletterForm.data('action'));

  /* ================================
   * Show password
   * ================================ */
  var passwordBlocks = document.querySelectorAll('.js-password');
  passwordBlocks.forEach(function (passwordBlock) {
    var button = passwordBlock.querySelector('.show-hide__button');
    var input = passwordBlock.querySelector('input[type=password]');
    button.addEventListener('click', function () {
      passwordBlock.classList.toggle('is-show');
      if (input.type === 'password') {
        input.type = 'text';
      } else {
        input.type = 'password';
      }
    });
  });

  /* ================================
   * Init pages
   * ================================ */

  Utils.hasMethod(Vars.parent, Vars.child);

  /* ================================
   * ./Init page
   * ================================ */

  return _;
};
